import gql from 'graphql-tag';

export const PublishMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation PublishMutation(
			$contentId: ID!
			$contentType: String!
			$content: String!
			$message: String
			$spaceKey: String!
			$suppressNotifyWatchers: Boolean
			$ncsStepVersion: String!
			$title: String!
			$version: Int!
			$schedulePublishDate: String
			$ancestors: [Ancestor]
			$moveRequest: MoveRequestObj
			$restrictions: ContentRestrictionsObj
			$isBlueprintCreate: Boolean
		) @experimental {
			experimentalPublishEditorContent(
				contentId: $contentId
				contentType: $contentType
				content: $content
				message: $message
				spaceKey: $spaceKey
				ncsStepVersion: $ncsStepVersion
				suppressNotifyWatchers: $suppressNotifyWatchers
				title: $title
				version: $version
				schedulePublishDate: $schedulePublishDate
				ancestors: $ancestors
				moveRequest: $moveRequest
				restrictions: $restrictions
				isBlueprintCreate: $isBlueprintCreate
			) {
				success
				status
				createdDate
				message
				traceId
				space {
					name
				}
			}
		}
	`;
